export default {
    'theme_title': {
        display: {
            name: '主題名稱',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'theme_title',
            data_type: 'file_url',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            name: 'theme_title'
        }
    },
}
  